
<div class="container" style="border:1px solid #bebaba">
  <br />
  <div class="row indentContent">
    <div class="col-md-12">
      <h3 style="font-weight:bold">Court Documents</h3>
      <p>Please use the links below to view a full copy of the various Court Documents.</p>
      <ul>
        <li>
          <a href="../../../assets/docs/DPP Motion for Common Benefit Set-Aside Order.pdf"
             target="_blank">
            DPP Motion for Common Benefit Set-Aside Order
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/DPP Memo in Support of Motion for Common Benefit Set-Aside Order.pdf"
             target="_blank">
            DPP Memo in Support of Motion for Common Benefit Set-Aside Order
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Declaration of B. Clark in Support of Motion for Set-Aside Order.pdf"
             target="_blank">
            Declaration of B. Clark in Support of Motion for Set-Aside Order
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Defendant's Opposition to DPP Set-Aside Order.pdf"
             target="_blank">
            Defendant's Opposition to DPP Set-Aside Order
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Tyson's Opposition to DPP Set-Aside Order.pdf"
             target="_blank">
            Tyson's Opposition to DPP Set-Aside Order
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Winn-Dixie DAPs Opposition to DPP Set-Aside Order.pdf"
             target="_blank">
            Winn-Dixie DAPs Opposition to DPP Set-Aside Order
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Carina DAPs Opposition to DPP Set-Aside Order.pdf"
             target="_blank">
            Carina DAPs Opposition to DPP Set-Aside Order
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Dec of C. Goonow in Support of Carina DAPs Opposition to DPP Set-Aside Order.pdf"
             target="_blank">
            Dec of C. Goonow in Support of Carina DAPs Opposition to DPP Set-Aside Order
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Reply in Support of Motion for Set Aside Order.pdf"
             target="_blank">
            Reply Memorandum in Support of Motion for Set Aside Order
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Declaration of Brian Clark in Support of Reply Memo.pdf"
             target="_blank">
            Declaration of Brian Clark in Support of Reply Memo
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Direct Purchaser Plaintiffs' Motion for Interim Payment of Attorneys' Fees.pdf"
             target="_blank">
            Direct Purchaser Plaintiffs' Motion for Interim Payment of Attorneys' Fees Reimbursement of Litigation Expenses and Class Representative Service Awards
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Memo ISO of Direct Purchaser Plaintiffs' Motion for Interim Payment of Attorneys' Fees.pdf"
             target="_blank">
            Memo ISO of Direct Purchaser Plaintiffs' Motion for Interim Payment of Attorneys' Fees Reimbursement of Litigation Expenses
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Declaration of B. Clark ISO DPP Motion for Int Payment of Fees, Lit Expenses & Service Awards.pdf"
             target="_blank">
            Declaration of B. Clark ISO DPP Motion for Int Payment of Fees, Lit Expenses & Service Awards
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Order Granting DPP Mtn for Atty Fees etc..pdf"
             target="_blank">
            Order Granting DPP Motion for Attorneys' Fees
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-10-16 (1983) DPP Mot. for Atty Fees, Reimbursement of Expenses, etc..pdf"
             target="_blank">
            Motion for Attorney Fees, Reimbursemenr of Expenses, etc
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Proposed order on DPP Costs and Fees.pdf"
             target="_blank">
            Proposed Order on DDP Costs and Fees
          </a>
        </li>


      </ul>
      <b>Notice of Settlements with Agri Stats, House of Raeford, Prestage, Foster Farms, Perdue, JOTS or Butterball Settlements</b>
      <ul>
        <li>
          <a href="../../../assets/docs/2026-08-26 - Butterball-JOTS MFPA Order and Notice Schedule.pdf"
             target="_blank">
            Order Granting Preliminary Approval of Settlements and Form of Class Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Exhibit 1 - Revised 8-26-26 Long Form Notice Draft 082026-Final.docx"
             target="_blank">
            Exhibit 1 - Long Form Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Exhibit 2 - Revised Short Form Notice 082026-Final.docx"
             target="_blank">
            Exhibit 2 - Short Form Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Exhibit 3 - Revised Turkey Banner Ad Filed.jpg"
             target="_blank">
            Exhibit 3 - Banner Ad
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/AgriStats/Exhibit 4 - Revised Claim Form-Final.pdf"
             target="_blank">
            Exhibit 4 - Claim Form
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Exhibit 5 - Revised Audit Request Form-Final.docx"
             target="_blank">
            Exhibit 5 - Audit Request Form
          </a>
        </li>
      </ul>
      <b>Agri Stats Settlement</b>
      <ul>
        <li>
          <a href="../../../assets/docs/5 - Minute Entry Scheduling Hearing (ECF 1777).pdf"
             target="_blank">
            Minute Entry Scheduling Hearing
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-03-31 (1772) DPP Mot. for Preliminary Approval of Agri Stats Settlement.pdf"
             target="_blank">
            DPP Mot. for Preliminary Approval of Agri Stats Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-03-31 (1773) Memo ISO DPP Mot. for Preliminary Approval of Agri Stats Settlement.pdf"
             target="_blank">
            Memo ISO DPP Mot. for Preliminary Approval of Agri Stats Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-03-31 (1773-1) S. Scarlett Dec ISO DPP Mot. for Preliminary Approval of Agri Stats Settlement.pdf"
             target="_blank">
            S. Scarlett Dec ISO DPP Mot. for Preliminary Approval of Agri Stats Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-03-31 (1773-2) Ex. A S. Scarlett Dec ISO DPP Mot. for Preliminary Approval of Agri Stats Settlement.pdf"
             target="_blank">
            Ex. A S. Scarlett Dec ISO DPP Mot. for Preliminary Approval of Agri Stats Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-03-31 (1773-4) B. Devery (AB Data) Dec ISO DPP Mot. for Preliminary Approval of Agri Stats Settlement.pdf"
             target="_blank">
            B. Devery (AB Data) Dec ISO DPP Mot. for Preliminary Approval of Agri Stats Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-04-16 (1794) Order Granting DPP and Agri Stats Preliminary Approval.pdf"
             target="_blank">
            Order Granting DPP and Agri Stats Preliminary Approval
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-04-28 (1797) DPP Mot. Requesting Amended Order re DPP and Agri Stats Preliminary Approval.pdf"
             target="_blank">
            DPP Mot. Requesting Amended Order re DPP and Agri Stats Preliminary Approval
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-04-29 (1799) Amended Order Granting DPP and Agri Stats Preliminary Approval.pdf"
             target="_blank">
            Amended Order Granting DPP and Agri Stats Preliminary Approva
          </a>
        </li>
      </ul>
      <b>House of Raeford, Prestage, Foster Farms, and Perdue Settlement</b>
      <ul>
        <li>
          <a href="../../../assets/docs/2026-07-30 (1902) Order Granting Prelim Approval of HRF, Prestage, FF, and Perdue.pdf"
             target="_blank">
            Order Granting Preliminary Approval of Settlements with House of Raeford, Prestage, Foster Garms, and Perdue
          </a>
        </li>
      </ul>
      <b>Hormel Foods and Jennie-O Turkey Store, Inc. Settlement</b>
      <ul>
        <li>
          <a href="../../../assets/docs/HormelJennieO/2026-08-14 (1936) Mot. for Preliminary Approval of JOTS Settlement.pdf"
             target="_blank">
            Motion for Preliminary Approval of Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/HormelJennieO/2026-08-14 (1937) Memo ISO Mot. for Preliminary Approval of JOTS Settlement.pdf"
             target="_blank">
            Memorandum in Support of Motion for Preliminary Approval of Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/HormelJennieO/2026-08-14 (1938) B. Clark Decl. ISO Mot. for Preliminary Approval of JOTS Settlement.pdf"
             target="_blank">
            Declaration of B. D. Clark in Support of Motion for Preliminary Approval of Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/HormelJennieO/2026-08-14 (1938-1) Ex. A to B. Clark Decl. ISO Mot. for Preliminary Approval of JOTS Settlement.pdf"
             target="_blank">
            Exhibit A - Hormel Settlement Agreement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/HormelJennieO/2026-08-14 (1939) Huntington Decl. ISO Mot. for Preliminary Approval of JOTS Settlement.pdf"
             target="_blank">
            Declaration of Huntington National Bank in Support of Motion for Preliminary Approval of Settlements
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/HormelJennieO/2026-08-14 (1939-1) Ex. A to Huntington Decl. ISO Mot. for Preliminary Approval of JOTS Settlement.pdf"
             target="_blank">
            Exhibit A - Huntington's Dedicated Team
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/HormelJennieO/2026-08-14 (1939-B) Ex. B to Huntington Decl. ISO Mot. for Preliminary Approval of JOTS Settlement.pdf"
             target="_blank">
            Exhibit B - Huntington Diversity and Inclusion Statement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/HormelJennieO/2026-08-14 (1940) AB Data Decl. ISO Mot. for Preliminary Approval of JOTS Settlement.pdf"
             target="_blank">
            Declaration of B. Devery in Support of Motion for Preliminary Approval of Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/HormelJennieO/2026-08-14 (1940-1) Ex. 1 to AB Data Decl. ISO Mot. for Preliminary Approval of JOTS Settlement.pdf"
             target="_blank">
            Exhibit 1 - Long Form Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/HormelJennieO/2026-08-14 (1940-2) Ex. 2 to AB Data Decl. ISO Mot. for Preliminary Approval of JOTS Settlement.pdf"
             target="_blank">
            Exhibit 2 - Short Form Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/HormelJennieO/2026-08-14 (1940-3) Ex. 3 to AB Data Decl. ISO Mot. for Preliminary Approval of JOTS Settlement.pdf"
             target="_blank">
            Exhibit 3 - Banner Ad
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/HormelJennieO/2026-08-14 (1940-4) Ex. 4 to AB Data Decl. ISO Mot. for Preliminary Approval of JOTS Settlement.pdf"
             target="_blank">
            Exhibit 4 - A.B. Data's profile
          </a>
        </li>
      </ul>


      <b>Butterball, LLC Settlement </b>
      <ul>
        <li>
          <a href="../../../assets/docs/Butterball/2026-08-21 (1955) DPP's Mot. for Prelim. Approval of Butterball Settlement.pdf"
             target="_blank">
            Unopposed Motion for Preliminary Approval of Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Butterball/2026-08-21 (1956) Memo ISO DPP's Mot. for Prelim. Approval of Butterball Settlement.pdf"
             target="_blank">
            Memorandum in Support of Unopposed Motion for Preliminary Approval of Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Butterball/2026-08-21 (1957) B. Clark Decl. ISO DPP's Mot. for Prelim. Approval of Butterball Settlement.pdf"
             target="_blank">
            Declaration of B.D. Clark in Support of Unopposed Motion for Preliminary Approval of Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Butterball/2026-08-21 (1957-1) Ex. A to B. Clark Decl. ISO DPP's Mot. for Prelim. Approval of Butterball Settlement.pdf"
             target="_blank">
            Butterball LLC Settlement Agreement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Butterball/2026-08-21 (1958) Huntington Bank Decl. ISO DPP's Mot. for Prelim. Approval of Butterball Settlement.pdf"
             target="_blank">
            Declaration of Hutington National Bank in Support of Unopposed Motion for Preliminary Approval of Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Butterball/2026-08-21 (1958-1) Ex. A to Huntington Bank Decl. ISO DPP's Mot. for Prelim. Approval of Butterball Settlement.pdf"
             target="_blank">
            Exhibit A - Huntington's Dedicated Team
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Butterball/2026-08-21 (1958-2) Ex. B to Huntington Bank Decl. ISO DPP's Mot. for Prelim. Approval of Butterball Settlement.pdf"
             target="_blank">
            Exhibit B - Huntington Diversity and Inclusion Statement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Butterball/2026-08-21 (1959) AB Data Decl. ISO DPP's Mot. for Prelim. Approval of Butterball Settlement.pdf"
             target="_blank">
            Declaration of B. Devery in Support of Unopposed Motion for Preliminary Approval of Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Butterball/2026-08-21 (1959-1) Ex. 1 to AB Data Decl. ISO DPP's Mot. for Prelim. Approval of Butterball Settlement.pdf"
             target="_blank">
            Exhibit 1 - Long Form Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Butterball/2026-08-21 (1959-2) Ex. 2 to AB Data Decl. ISO DPP's Mot. for Prelim. Approval of Butterball Settlement.pdf"
             target="_blank">
            Exhibit 2 - Short Form Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Butterball/2026-08-21 (1959-3) Ex. 3 to AB Data Decl. ISO DPP's Mot. for Prelim. Approval of Butterball Settlement.pdf"
             target="_blank">
            Exhibit 3 - Banner Ad
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Butterball/2026-08-21 (1959-4) Ex. 4 to AB Data Decl. ISO DPP's Mot. for Prelim. Approval of Butterball Settlement.pdf"
             target="_blank">
            Exhibit 4 - Prepopulated Claim Form
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Butterball/2026-08-21 (1959-5) Ex. 5 to AB Data Decl. ISO DPP's Mot. for Prelim. Approval of Butterball Settlement.pdf"
             target="_blank">
            Exhibit 5 - Claim Form
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Butterball/2026-08-21 (1959-6) Ex. 6 to AB Data Decl. ISO DPP's Mot. for Prelim. Approval of Butterball Settlement.pdf"
             target="_blank">
            Exhibit 6 - A.B. Data's profile
          </a>
        </li>
      </ul>

      <b>Notice of Settlements with Agri Stats, House of Raeford, Prestage, Foster Farms, Perdue, JOTS or Butterball Settlements</b>
      <ul>
        <li>
          <a href="../../../assets/docs/AgriStats/2026-08-26 - Butterball-JOTS MFPA Order and Notice Schedule.pdf"
             target="_blank">
            Order Granting Preliminary Approval of Settlements and Form of Class Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/AgriStats/Exhibit 1 - Revised 8-26-26 Long Form Notice Draft 082026-Final.docx"
             target="_blank">
            Exhibit 1 - Long Form Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/AgriStats/Exhibit 2 - Revised Short Form Notice 082026-Final.docx"
             target="_blank">
            Exhibit 2 - Short Form Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/AgriStats/Exhibit 3 - Revised Turkey Banner Ad Filed.jpg"
             target="_blank">
            Exhibit 3 - Banner Ad
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/AgriStats/Exhibit 4 - Revised Claim Form-Final.pdf"
             target="_blank">
            Exhibit 4 - Claim Form
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/AgriStats/Exhibit 5 - Revised Audit Request Form-Final.docx"
             target="_blank">
            Exhibit 5 - Audit Request Form
          </a>
        </li>
      </ul>

      <b>Class Certification, Cooper Farms & Farbest Foods Settlements</b>
      <ul>
        <li>
          <a href="/docs/Certified/Order for Final Approval of Cooper Farms & Farbest Foods Settlements.pdf"
             target="_blank">
            Order for Final Approval of Cooper Farms & Farbest Foods Settlements
          </a>
        </li>
        <li>
          <a href="/docs/Certified/Settlement Agreement with Cooper Farms.pdf"
             target="_blank">
            Settlement Agreement with Cooper Farms
          </a>
        </li>
        <li>
          <a href="/docs/Certified/Settlement Agreement with Farbest Foods.pdf"
             target="_blank">
            Settlement Agreement with Farbest Foods
          </a>
        </li>
        <li>
          <a href="/docs/Certified/Preliminary Approval Order.pdf"
             target="_blank">
            Preliminary Approval Order
          </a>
        </li>
        <li>
          <a href="/docs/Certified/DPP Motion for Preliminary Approval of Settlements with Cooper & Farbest.pdf"
             target="_blank">
            DPP Motion for Preliminary Approval of Settlements with Cooper & Farbest
          </a>
        </li>
        <li>
          <a href="/docs/Certified/DPP Memo in Support of Motion for Prelim Approval.pdf"
             target="_blank">
            DPP Memo in Support of Motion for Prelim Approval
          </a>
        </li>
        <li>
          <a href="/docs/Certified/Declaration of B Clark in Support of Motion for Prelim Approval.pdf"
             target="_blank">
            Declaration of B Clark in Support of Motion for Prelim Approval
          </a>
        </li>
        <li>
          <a href="/docs/Certified/Declaration of E Schachter in Support of Motion for Prelim Approval.pdf"
             target="_blank">
            Declaration of E Schachter in Support of Motion for Prelim Approval
          </a>
        </li>
        <li>
          <a href="/docs/Certified/Declaration of Huntington Bank in Support of Motion for Prelim Approval.pdf"
             target="_blank">
            Declaration of Huntington Bank in Support of Motion for Prelim Approval
          </a>
        </li>
      </ul>
      <b>Cargill Settlement</b>
      <ul>
        <li>
          <a href="../../../assets/docs/CourtDocsCargill/Long form settlement agreement with Cargill.pdf"
             target="_blank">
            Settlement Agreement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/CourtDocsCargill/Cargill Preliminary approval order.pdf"
             target="_blank">
            Preliminary Approval Order
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/CourtDocsCargill/Motion For Preliminary Approval with Cargill.pdf"
             target="_blank">
            Motion for Preliminary Approval with Cargill
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/CourtDocsCargill/DPP Memo In Support of Preliminary Approval of Settlement with Cargill.pdf"
             target="_blank">
            DPP Memo In Support of Preliminary Approval of Settlement with Cargill
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/CourtDocsCargill/B. Clark Declaration In Support of Preliminary Settlement Approval with Cargill.pdf"
             target="_blank">
            B. Clark Declaration In Support of Preliminary Settlement Approval with Cargill
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/CourtDocsCargill/E. Schachter Declaration In Support of Preliminary Settlement Approval with Cargill.pdf"
             target="_blank">
            E. Schachter Declaration In Support of Preliminary Settlement Approval with Cargill
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/CourtDocsCargill/Huntington Declaration In Support of Preliminary Settlement Approval with Cargill.pdf"
             target="_blank">
            Huntington Declaration In Support of Preliminary Settlement Approval with Cargil
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/CourtDocsCargill/Final Order Approving DPP and Cargill Settlement with Exhibits.pdf"
             target="_blank">
            Final Order Approving DPP and Cargill Settlement with Exhibits
          </a>
        </li>
      </ul>
      <b>Tyson Settlement</b>
      <ul>
        <li>
          <a href="../../../assets/docs/CourtDocsTyson/2021-05-14 EXECUTED DPP Tyson Settlement Agreement.pdf"
             target="_blank">
            Settlement Agreement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/CourtDocsTyson/2021-05-25 - Tyson prelim approval order.pdf"
             target="_blank">
            Preliminary Approval Order
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/CourtDocsTyson/Docket Entry.pdf"
             target="_blank">
            Notice of Docket Entry
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/CourtDocsTyson/Supplemental Declaration in Regard to updated notice plan.pdf"
             target="_blank">
            Unopposed Motion to Amend the Court-Ordered Notice Plan
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/CourtDocsTyson/UNOPPOSED MOTION TO AMEND THE COURT-ORDERED PLAN.pdf"
             target="_blank">
            Memorandum in Support of Unopposed Motion to Amend Court Ordered Plan
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/CourtDocsTyson/Supplemental Declaration in Regard to updated notice plan.pdf"
             target="_blank">
            Supplemental Delcaration Regarding the Updated Notice Plan
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/CourtDocsTyson/Order Granting Extended Deadline to Provide Notice.pdf"
             target="_blank">
            Order Granting Extended Notice Deadline
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/CourtDocsTyson/Order and Final Judgement for Final Approval- Tyson Settlement.pdf"
             target="_blank">
            Order and Final Judgement for Final Approval
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div style="width:80%; margin:0 auto; text-align: center; display:block; margin-top: 2%">
    <p>
      Note: These documents are in PDF format. To view the<br />
      documents, you will need <a href="https://get.adobe.com/reader/" target="_blank"
                                  style="color:#0071ce; font-weight:bold">Adobe Acrobat Reader</a>
      on your computer or other internet-enabled device.
    </p>
  </div>
  <div class="row text-center" id="inverse_row">
    <div class="col-md-12">
      <a href="https://get.adobe.com/reader/" target="_blank"><img src="../assets/adobe-pdf-icon.jpg" alt="Adobe Acrobat Reader" width="3%"></a>
    </div>
  </div>
  <br />
</div>
